module.exports = __webpack_public_path__ + "images/select2-spinner.gif";